import { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/dist/client/router";
import { Fragment, VFC } from "react";
import { PageHeader, SEO } from "~/components";
import { useTranslation } from "~/hooks";
import { Article } from "~/layouts";
import { fetchAllNews, fetchNewsById, News } from "~/lib/server/microcms";

type Props = {
  news: News;
};

export const getStaticProps: GetStaticProps<Props> = async (ctx) => {
  const { id } = ctx.params as {
    id: string;
  };
  const news = await fetchNewsById(id);
  if (!news) {
    return {
      notFound: true,
      revalidate: 60
    };
  }
  return {
    props: {
      news
    },
    revalidate: 60
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const news = await fetchAllNews();
  return {
    paths: news.contents.map((item) => `/news/article/${item.id}`),
    fallback: true
  };
};

const NewsArticlePage: VFC<Props> = ({ news }) => {
  const { dic } = useTranslation();
  const { isFallback } = useRouter();
  return !isFallback ? (
    <Article>
      <SEO pageName={news.title} path={`/news/article/${news.id}`} />
      <PageHeader
        labelText="News"
        headingText={news.title}
        crumbs={[
          {
            label: dic.homepage,
            path: "/"
          },
          {
            label: dic.navigation.news,
            path: "/news"
          },
          {
            label: news.title
          }
        ]}
      />
      <Article.Section>
        <Article.Details
          dateString={news.publishedAt}
          bodyHtml={news.content}
        />
      </Article.Section>
    </Article>
  ) : (
    <Fragment />
  );
};

export default NewsArticlePage;
